import React from 'react';
import PropTypes from 'prop-types';

// Components
import ClickableChip from "components/WMS/ClickableChip";

Toggle.propTypes = {
    label: PropTypes.any,
    count: PropTypes.number,
    checked: PropTypes.bool,
    onClick: PropTypes.func,
    fullWidth: PropTypes.bool,
};

function Toggle({label, count, checked, onClick, round= false, noWrapText = false, large = false, fullWidth = false, ...props}) {
    return (
       <ClickableChip
           label={label}
           checked={checked}
           onClick={onClick}
           count={count}
           round={round}
           noWrapText={noWrapText}
           large={large}
           fullWidth={fullWidth}
       >
           {props.children}
       </ClickableChip>
    );
}

export default Toggle;
